import { KreFormFieldConfig } from "@kre-form/core";
import * as _ from "lodash";
export function getFieldPro(field: KreFormFieldConfig, key: string) {
  return _.get(field, "templateOptions." + key + "");
}
export function requiredValidationMessage(err: any, field: KreFormFieldConfig) {
  return `${getFieldPro(field, "label")}不能为空`;
}
export function minlengthValidationMessage(
  err: any,
  field: KreFormFieldConfig
) {
  return `${getFieldPro(field, "label")}最小长度为${getFieldPro(
    field,
    "minLength"
  )}`;
}
export function maxlengthValidationMessage(
  err: any,
  field: KreFormFieldConfig
) {
  return `${getFieldPro(field, "label")}最大长度为${getFieldPro(
    field,
    "maxLength"
  )}`;
}
export function minValidationMessage(err: any, field: KreFormFieldConfig) {
  return `${getFieldPro(field, "label")}最小值为${getFieldPro(field, "min")}`;
}
export function maxValidationMessage(err: any, field: KreFormFieldConfig) {
  return `${getFieldPro(field, "label")}最大值为${getFieldPro(field, "max")}`;
}
export function patternMessage(err: any, field: KreFormFieldConfig) {
  if (!!field && !!field.templateOptions && !!field.templateOptions.errorMsg) {
    return `${getFieldPro(field, "label")}${field.templateOptions.errorMsg}`;
  } else {
    return `${getFieldPro(field, "label")}不满足规则`;
  }
}

export let validationConfig = {
  validationMessages: [
    { name: "required", message: requiredValidationMessage },
    { name: "null", message: "不能为NULL" },
    { name: "minlength", message: minlengthValidationMessage },
    { name: "maxlength", message: maxlengthValidationMessage },
    { name: "min", message: minValidationMessage },
    { name: "max", message: maxValidationMessage },
    { name: "multipleOf", message: "ssss" },
    { name: "exclusiveMinimum", message: "ssss" },
    { name: "exclusiveMaximum", message: "ssss" },
    { name: "minItems", message: "ssss" },
    { name: "maxItems", message: "ssss" },
    { name: "uniqueItems", message: "should NOT have duplicate items" },
    { name: "const", message: "ssss" },
    // { name: "pattern", message: "不满足正则表达式" },
    { name: "pattern", message: patternMessage },
  ],
  types: [
    // { name: "string", extends: "input" },
    // {
    //   name: "number",
    //   extends: "input",
    //   defaultOptions: {
    //     templateOptions: {
    //       type: "number"
    //     }
    //   }
    // },
    // {
    //   name: "integer",
    //   extends: "input",
    //   defaultOptions: {
    //     templateOptions: {
    //       type: "number"
    //     }
    //   }
    // },
    // { name: "boolean", extends: "checkbox" },
    // { name: "enum", extends: "select" },
    { name: "array", extends: "array" },
    { name: "object", extends: "object" },
  ],
};
